import { useContext } from 'react';
import { TracingContext } from '../Contexts';
const useTracing = () => {
    return useContext(TracingContext);
};
export default useTracing;
